import { render, staticRenderFns } from "./FormBankAccount.vue?vue&type=template&id=21058034"
import script from "./FormBankAccount.vue?vue&type=script&lang=js"
export * from "./FormBankAccount.vue?vue&type=script&lang=js"
import style0 from "./FormBankAccount.vue?vue&type=style&index=0&id=21058034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports